// extracted by mini-css-extract-plugin
module.exports = {"gridContent":"page-body__gridContent____3hcie","container":"full-width__container____7enNS"};